import * as React from 'react';

import {EntityPill} from '../entity-pill/entity-pill';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';
import type {Truncate} from '../typography/body';

type Subtitle = {
    text: string;
    isItalic?: boolean;
    isPill?: boolean;
};

type Props = {
    title: string;
    subtitles: Array<Subtitle>;
    truncate?: Truncate;
};

export function MultiLine(props: Props) {
    return (
        <Stack spacing={2} isFullWidth={true}>
            <Body size='small' nowrap={!props.truncate}>
                {props.title}
            </Body>
            {props.subtitles.map((subtitle) => {
                if (!subtitle.text) {
                    return null;
                }

                return subtitle.isPill ? (
                    <div key={subtitle.text}>
                        <EntityPill
                            name={
                                <Body
                                    size='mini'
                                    truncate={props.truncate}
                                    color='light'
                                    isBold={true}
                                >
                                    {subtitle.text}
                                </Body>
                            }
                            type='light'
                            isSmall={true}
                        />
                    </div>
                ) : (
                    <Body
                        size='mini'
                        nowrap={true}
                        key={subtitle.text}
                        truncate={props.truncate}
                        isItalic={subtitle.isItalic}
                    >
                        {subtitle.text}
                    </Body>
                );
            })}
        </Stack>
    );
}
